import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useReceiptContext } from './context/receipt.context';
import LandingView from './views/landing.view';
import PostLoginView from './views/post-login.view';
import VerifyView from './views/verify.view';
import VerifyOnceView from './views/verify-once.view';
import AlreadyClaimedView from './views/already-claimed.view';
import NotFoundView from './views/not-found.view';
import LockedOutView from './views/locked-out.view';

const ReceiptPage = () => {
  const { receiptId, setReceiptId } = useReceiptContext();
  const match = useRouteMatch('/:receiptId');
  const currentReceiptId = match?.params?.receiptId;
  const isPerksDisabled = window.Jbhifi.isPerksDisabled;

  useEffect(() => {
    if (!receiptId || receiptId !== currentReceiptId) {
      setReceiptId(currentReceiptId);
    }
  }, [match]);

  return (
    <Switch>
      <Route exact path="/" render={props => <NotFoundView {...props} />} />
      <Route exact path="/lockedout" render={props => <LockedOutView {...props} />} />
      <Route
        exact
        path="/:receiptId/post-login"
        render={props => <PostLoginView {...props} receiptId={currentReceiptId} />}
      />
      <Route exact path="/:receiptId/verify" render={props => <VerifyView {...props} receiptId={currentReceiptId} />} />
      <Route
        exact
        path="/:receiptId/verify-once"
        render={props => <VerifyOnceView {...props} receiptId={currentReceiptId} />}
      />
      <Route
        exact
        path="/:receiptId/already-claimed"
        render={props => (
          <AlreadyClaimedView {...props} receiptId={currentReceiptId} isPerksDisabled={isPerksDisabled} />
        )}
      />
      <Route exact path="/:receiptId" render={props => <LandingView {...props} receiptId={currentReceiptId} />} />
      <Redirect to="/" />
    </Switch>
  );
};

export default ReceiptPage;
